import * as React from 'react';
import { TeaserVideoWrapper } from './Video.s';

export const TeaserVideo: React.SFC<{}> = () => (
  <TeaserVideoWrapper preload="auto" controls={true} src={require('./medias/teaser.mp4')} />
);



// WEBPACK FOOTER //
// src/app/src/components/Videos/TeaserVideo.tsx